import { changeOverlayStatus } from '../../state/actionCreators/index'
import React, { Component } from 'react';
import axios from 'axios';
import '../../assets/css/Register.css';
import { connect } from 'react-redux';
import Button from '../Button';

class ForgotPasswordPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            displayPopup: false,
            error: '',
            msg: "",
        };
    }

    resetFields = () => {
        this.setState((prevState) => {
            return ({
                email: '',
                displayPopup: false,
                error: '',
                msg: "",
            })
        })
    }

    handleInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState((prevState) => {
            return ({
                ...prevState,
                [name]: value
            })
        })
    }

    openPopup = () => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                displayPopup: true,
            })
        })
        this.props.changeOverlayStatus('true');
    }

    closePopup = () => {
        this.resetFields();
        this.setState((prevState) => {
            return ({
                displayPopup: false,
            })
        })
        this.props.changeOverlayStatus('false');
    }

    updateErrorMessage = (error = "", msg = "") => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                error: error,
                msg: msg
            })
        })
    }

    sendMail = () => {

        this.setState((prevState) => {
            return ({
                ...prevState,
                error: "",
                msg: "",
            })
        })
       
        const requestBody = {email: this.state.email}
        axios.post(process.env.REACT_APP_SERVER_URL + `/user/resetPassword`, requestBody)
            .then(response => {
                this.updateErrorMessage("", "Email sent successfully!")
                // this.closePopup()
               
            })
            .catch(error => {
                console.error('Error sending email:', error);
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {

                        const fieldErrors = error.response.data.fieldErrors;
                        const firstKey = Object.keys(fieldErrors)[0];
                        const firstError = fieldErrors[firstKey];

                        this.setState((prevState) => ({
                            ...prevState,
                            error: firstError
                        }));
                    }
                    else {

                        this.setState((prevState) => {
                            return ({
                                ...prevState,
                                error: error.response.data
                            })
                        })
                    }
                }
            });
    }

    render () {

        let {displayPopup, error, email, msg} = this.state;
        return (
            <div className={'mjwi-popup mjwi-forgot-pwd-pp' + (displayPopup ? '' : ' mjwi-hidden')}>
                <div className="mjwi-forgotpwd">
                    <h2>Forgot Password</h2>
                    <span className="mjwi-popup-close" onClick={this.closePopup}>
                        <i className="fa-solid fa-xmark"></i>
                    </span>
                    <div className="mjwi-row">
                        <div className="mjwi-col100">
                            <input
                                type="test"
                                placeholder="Enter Email Address"
                                name="email"
                                value={email}
                                onChange={this.handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="mjwi-row">
                        <div className="mjwi-col50">
                            <Button name="Send mail" eventHandler={() => {this.sendMail()}} />
                        </div>
                        <div className="mjwi-col50">
                            <Button name="Cancel" eventHandler={() => {this.closePopup()}} />
                        </div>
                    </div>
                    <div className={'mjwi-error' + (error ? '' : ' mjwi-hidden')}>{error}</div>
                    <div className={'mjwi-msg' + (msg ? '' : ' mjwi-hidden')}>{msg}</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            overlay: state.overlay,
        }
    )
  }
  
  const mapDispatchToProps = (dispatch) => {
    return (
        {
            changeOverlayStatus: (status) => {dispatch(changeOverlayStatus(status))},
        }
    )
  }
  
  export default connect(mapStateToProps,mapDispatchToProps,null, {forwardRef: true} )(ForgotPasswordPopup);